import { render, staticRenderFns } from "./DatatableListPeople.vue?vue&type=template&id=7b7c1da3&scoped=true&"
import script from "./DatatableListPeople.vue?vue&type=script&lang=js&"
export * from "./DatatableListPeople.vue?vue&type=script&lang=js&"
import style0 from "./DatatableListPeople.vue?vue&type=style&index=0&id=7b7c1da3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7c1da3",
  null
  
)

export default component.exports